import { render, staticRenderFns } from "./CampaignMemberPointHistoryBody.vue?vue&type=template&id=efde8b90"
import script from "./CampaignMemberPointHistoryBody.vue?vue&type=script&lang=js"
export * from "./CampaignMemberPointHistoryBody.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports